import {AudioPlayerStateFactory} from '../../../../components/AudioPlayer/state/AudioPlayerState.factory';
import {AnswerFactory} from '../../../../core/domain/Answer/Answer.factory';
import {CheckboxesAnswerFactory} from '../../../../core/domain/Answer/CheckboxesAnswer/CheckboxesAnswerFactory';
import {MultipleChoiceAnswerFactory} from '../../../../core/domain/Answer/MultipleChoiceAnswer/MultipleChoiceAnswer.factory';
import {TextAnswerFactory} from '../../../../core/domain/Answer/TextAnswer/TextAnswerFactory';
import {AppEventController} from '../../../../core/domain/AppEvent/AppEvent.controller';
import {AppEventFactory} from '../../../../core/domain/AppEvent/AppEvent.factory';
import {ArticleFactory} from '../../../../core/domain/Article/Article.factory';
import {AssessmentFactory} from '../../../../core/domain/Assessment/Assessment.factory';
import {BoundAssessmentFactory} from '../../../../core/domain/BoundAssessment/BoundAssessment.factory';
import {CardController} from '../../../../core/domain/Card/Card.controller';
import {CardFactory} from '../../../../core/domain/Card/Card.factory';
import {CategoryController} from '../../../../core/domain/Category/Category.controller';
import {CategoryFactory} from '../../../../core/domain/Category/Category.factory';
import {CoachHistoryController} from '../../../../core/domain/CoachHistory/CoachHistory.controller';
import {CoachHistoryFactory} from '../../../../core/domain/CoachHistory/CoachHistory.factory';
import {PaymentPlanFactory} from '../../../../core/domain/common/PaymentPlan/PaymentPlan.factory';
import {PrivateProfileFactory} from '../../../../core/domain/common/PrivateProfile/PrivateProfile.factory';
import {ProgramDurationFactory} from '../../../../core/domain/common/ProgramDuration/ProgramDuration.factory';
import {UserAdditionalDataFactory} from '../../../../core/domain/common/UserAdditionalData/UserAdditionalData.factory';
import {ConferenceController} from '../../../../core/domain/Conference/Conference.controller';
import {ConferenceFactory} from '../../../../core/domain/Conference/Conference.factory';
import {CouponController} from '../../../../core/domain/Coupon/Coupon.controller';
import {CouponFactory} from '../../../../core/domain/Coupon/Coupon.factory';
import {CourseController} from '../../../../core/domain/Course/Course.controller';
import {CourseFactory} from '../../../../core/domain/Course/Course.factory';
import {CurrencyFactory} from '../../../../core/domain/Currency/Currency.factory';
import {DateTimeModelFactory} from '../../../../core/domain/Date/DateTime.factory';
import {EditionFactory} from '../../../../core/domain/Edition/Edition.factory';
import {FileController} from '../../../../core/domain/File/File.controller';
import {FileFactory} from '../../../../core/domain/File/File.factory';
import {FollowerController} from '../../../../core/domain/Follower/Follower.controller';
import {FollowerFactory} from '../../../../core/domain/Follower/Follower.factory';
import {FoodDiaryFactory} from '../../../../core/domain/FoodDiary/FoodDiary.factory';
import {GoalFactory} from '../../../../core/domain/Goal/Goal.factory';
import {MembershipController} from '../../../../core/domain/Membership/Membership.controller';
import {MembershipFactory} from '../../../../core/domain/Membership/Membership.factory';
import {MetricFactory} from '../../../../core/domain/Metric/Metric.factory';
import {OfferController} from '../../../../core/domain/Offer/Offer.controller';
import {OfferFactory} from '../../../../core/domain/Offer/Offer.factory';
import {PaymentController} from '../../../../core/domain/Payment/Payment.controller';
import {PaymentFactory} from '../../../../core/domain/Payment/Payment.factory';
import {PriceFactory} from '../../../../core/domain/Price/Price.factory';
import {ProgramController} from '../../../../core/domain/Program/Program.controller';
import {ProgramFactory} from '../../../../core/domain/Program/Program.factory';
import {ChoiceQuestionFactory} from '../../../../core/domain/Question/ChoiceQuestion/ChoiceQuestion.factory';
import {QuestionFactory} from '../../../../core/domain/Question/Question.factory';
import {TextQuestionFactory} from '../../../../core/domain/Question/TextQuestion/TextQuestion.factory';
import {RefundController} from '../../../../core/domain/Refund/Refund.controller';
import {RefundFactory} from '../../../../core/domain/Refund/Refund.factory';
import {SubgoalFactory} from '../../../../core/domain/Subgoal/Subgoal.factory';
import {SubtenantController} from '../../../../core/domain/Subtenant/Subtenant.controller';
import {SubtenantFactory} from '../../../../core/domain/Subtenant/Subtenant.factory';
import {SubtenantArticlesAccessModelFactory} from '../../../../core/domain/Subtenant/SubtenantArticlesAccess.factory';
import {SubtenantExtensionConfigurationFactory} from '../../../../core/domain/Subtenant/SubtenantExtensionConfiguration.factory';
import {TaskController} from '../../../../core/domain/Task/Task.controller';
import {TaskFactory} from '../../../../core/domain/Task/Task.factory';
import {TenantController} from '../../../../core/domain/Tenant/Tenant.controller';
import {TenantFactory} from '../../../../core/domain/Tenant/Tenant.factory';
import {UserController} from '../../../../core/domain/User/User.controller';
import {UserFactory} from '../../../../core/domain/User/User.factory';
import {UserMetadataFactory} from '../../../../core/domain/User/UserMetadata/UserMetadata.factory';
import {UserOnboardingFactory} from '../../../../core/domain/User/UserOnboarding/UserOnboarding.factory';
import {WaitlistItemFactory} from '../../../../core/domain/WaitlistItem/WaitlistItem.factory';
import {WsMessageController} from '../../../../core/domain/WsMessage/WsMessage.controller';
import {WsMessageFactory} from '../../../../core/domain/WsMessage/WsMessage.factory';
import {AudioModelFactory} from '../../../../core/models/Audio/AudioModel.factory';
import {CachedMediaFactory} from '../../../../core/models/CachedMedia/CachedMedia.factory';
import {MissedCromsCountStore} from '../../../../core/stores/MissedCromsCount.store';
import {UserWaitlistStore} from '../../../../core/stores/UserWaitlist.store';
import {FetchCurrentUserCardsListUseCase} from '../../../../core/useCases/Card/FetchCurrentUserCardsList.uc';
import {FetchCategoriesUseCase} from '../../../../core/useCases/Category/FetchCategories.uc';
import {CreateCourseUseCase} from '../../../../core/useCases/Course/CreateCourse.uc';
import {ReadFileUseCase} from '../../../../core/useCases/File/ReadFile.uc';
import {UploadFileUseCase} from '../../../../core/useCases/File/UploadFile.uc';
import {FetchProgramGoalsUseCase} from '../../../../core/useCases/Goal/FetchProgramGoals.uc';
import {FetchPreviousGoalsUseCase} from '../../../../core/useCases/Goal/FetchUnboundGoals.uc';
import {GetMediaCachedUrlUseCase} from '../../../../core/useCases/Media/GetMediaCachedUrl/GetMediaCachedUrl.uc';
import {SaveMediaToCachedMediaDbUseCase} from '../../../../core/useCases/Media/SaveMediaToCachedMediaDb.uc';
import {ToggleEmployeeSubscriptionUseCase} from '../../../../core/useCases/Membership/ToggleEmployeeSubscription.uc';
import {FetchUserUseCase} from '../../../../core/useCases/User/FetchUser.uc';
import {FetchUserWaitlistItemsUseCase} from '../../../../core/useCases/User/FetchUserWaitlistItems.uc';
import {ArticleAudioPlayerStateFactory} from '../../../../modules/articles/ui/components/ArticleAudioPlayer/state/ArticleAudioPlayerState.factory';
import {VoiceAttachmentStateFactory} from '../../../../modules/chats/attachment/components/Attachment/Voice/VoiceAttachmentState.factory';
import {CheckIsUserCoachClientUseCase} from '../../../../modules/user-profile-v2/useCases/CheckIsUserCoachClient.uc';
import {FetchLastMembershipUseCase} from '../../../../modules/user-profile-v2/useCases/FetchLastMembership.uc';
import {ImageModelFactory} from '../../../../uikit/Image/model/ImageModelFactory';
import {VideoPlayerStateFactory} from '../../../../uikit/VideoPlayer/state/VideoPlayerStateFactory';
import {ContainerBinder} from '../../../ContainerBinder';

const bindUseCases = (container: ContainerBinder.Container) => {
  return new ContainerBinder(container)
    .bindSingleton(CheckIsUserCoachClientUseCase)
    .bindSingleton(UploadFileUseCase)
    .bindSingleton(FetchLastMembershipUseCase)
    .bindSingleton(FetchUserUseCase)
    .bindSingleton(ReadFileUseCase)
    .bindSingleton(FetchCategoriesUseCase)
    .bindSingleton(FetchCurrentUserCardsListUseCase)
    .bindSingleton(ToggleEmployeeSubscriptionUseCase)
    .bindSingleton(FetchUserWaitlistItemsUseCase)
    .bindSingleton(GetMediaCachedUrlUseCase)
    .bindSingleton(SaveMediaToCachedMediaDbUseCase)
    .bindSingleton(FetchPreviousGoalsUseCase)
    .bindSingleton(FetchProgramGoalsUseCase)
    .bindSingleton(CreateCourseUseCase)
    .done();
};

const bindControllers = (container: ContainerBinder.Container) => {
  return new ContainerBinder(container)
    .bindSingleton(CardController)
    .bindSingleton(CategoryController)
    .bindSingleton(ConferenceController)
    .bindSingleton(CourseController)
    .bindSingleton(FileController)
    .bindSingleton(FollowerController)
    .bindSingleton(MembershipController)
    .bindSingleton(PaymentController)
    .bindSingleton(RefundController)
    .bindSingleton(SubtenantController)
    .bindSingleton(TaskController)
    .bindSingleton(TenantController)
    .bindSingleton(UserController)
    .bindSingleton(WsMessageController)
    .bindSingleton(ProgramController)
    .bindSingleton(AppEventController)
    .bindSingleton(OfferController)
    .bindSingleton(CoachHistoryController)
    .bindSingleton(CouponController)
    .done();
};

const bindFactories = (container: ContainerBinder.Container) => {
  return new ContainerBinder(container)
    .bindSingleton(UserAdditionalDataFactory)
    .bindSingleton(UserOnboardingFactory)
    .bindSingleton(AppEventFactory)
    .bindSingleton(ArticleFactory)
    .bindSingleton(CategoryFactory)
    .bindSingleton(ConferenceFactory)
    .bindSingleton(CourseFactory)
    .bindSingleton(DateTimeModelFactory)
    .bindSingleton(FileFactory)
    .bindSingleton(FollowerFactory)
    .bindSingleton(MembershipFactory)
    .bindSingleton(PrivateProfileFactory)
    .bindSingleton(ProgramFactory)
    .bindSingleton(SubtenantExtensionConfigurationFactory)
    .bindSingleton(SubtenantArticlesAccessModelFactory)
    .bindSingleton(SubtenantFactory)
    .bindSingleton(TaskFactory)
    .bindSingleton(TenantFactory)
    .bindSingleton(UserFactory)
    .bindSingleton(UserMetadataFactory)
    .bindSingleton(WsMessageFactory)
    .bindSingleton(CardFactory)
    .bindSingleton(PaymentFactory)
    .bindSingleton(RefundFactory)
    .bindSingleton(CurrencyFactory)
    .bindSingleton(PriceFactory)
    .bindSingleton(PaymentPlanFactory)
    .bindSingleton(OfferFactory)
    .bindSingleton(CoachHistoryFactory)
    .bindSingleton(AssessmentFactory)
    .bindSingleton(BoundAssessmentFactory)
    .bindSingleton(QuestionFactory)
    .bindSingleton(ChoiceQuestionFactory)
    .bindSingleton(TextQuestionFactory)
    .bindSingleton(AnswerFactory)
    .bindSingleton(MultipleChoiceAnswerFactory)
    .bindSingleton(TextAnswerFactory)
    .bindSingleton(CheckboxesAnswerFactory)
    .bindSingleton(WaitlistItemFactory)
    .bindSingleton(CachedMediaFactory)
    .bindSingleton(AudioModelFactory)
    .bindSingleton(AudioPlayerStateFactory)
    .bindSingleton(ArticleAudioPlayerStateFactory)
    .bindSingleton(VoiceAttachmentStateFactory)
    .bindSingleton(VideoPlayerStateFactory)
    .bindSingleton(ImageModelFactory)
    .bindSingleton(CouponFactory)
    .bindSingleton(FoodDiaryFactory)
    .bindSingleton(MetricFactory)
    .bindSingleton(GoalFactory)
    .bindSingleton(SubgoalFactory)
    .bindSingleton(EditionFactory)
    .bindSingleton(ProgramDurationFactory)
    .done();
};

const bindStores = (container: ContainerBinder.Container) => {
  return new ContainerBinder(container)
    .bindSingleton(MissedCromsCountStore)
    .bindSingleton(UserWaitlistStore)
    .done();
};

export const bindCoreApp = (container: ContainerBinder.Container) => {
  bindControllers(container);
  bindFactories(container);
  bindUseCases(container);
  bindStores(container);
};
